var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-display"},[(_vm.selectedItem)?_c('div',{staticClass:"isItem"},[_c('h1',[_vm._v(_vm._s(_vm.selectedItem.title))]),_c('p',[_vm._v(_vm._s(_vm.selectedItem.content))])]):_c('div',[_c('h1',[_vm._v("Selecciona un elemento")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }